import icons from '/src/assets/fonts/FontAwesome.ttf';
import glyphMap from '/src/assets/glyphmaps/FontAwesome.json';
import createIcon from './CreateIcon';

const iconSet = createIcon(glyphMap, 'FontAwesome', icons);
export default iconSet;
